import checkByID from './checkByID';

/**
 * Search by text in input
 */
export default function () {
    let searchInput = $('.js-services--search');

    $(searchInput).on('input paste', function () {
        let searchInputValue = $(searchInput).val();

        if (searchInputValue.length == 0 || searchInputValue.length > 2) {
            checkBySearch(searchInputValue);
        }
    });
}

/**
 * Check posts title with input text
 * @param {String} search
 */
function checkBySearch(search) {
    $('.js-archive-service-card').each(function (index, card) {
        if (!$(card).hasClass('hidden')) {
            let input = search.toLowerCase();
            let productTitle = String($(card).find('.js-archive-service-card--title').text()).toLowerCase().trim();

            if (productTitle.includes(input)) {
                $(card).show(0);
                $(card).removeClass('hidden');
            } else {
                $(card).hide(0);
                $(card).addClass('hidden');
            }
        }
    });

    // If search input is empty, show all posts from active category
    if (search.length === 0) {
        let categoryId = $('.js-services-category.active').data('id');
        checkByID(categoryId);
    }
}
